import { Box, ButtonBase, Dialog, Divider, Stack, Typography, styled } from '@mui/material';

import useLocales from '../../hooks/useLocales';
import Image from '../../components/Image';
import Iconify from '../../components/Iconify';
import { setIsOpenCS } from '../../redux/slices/settings';
import { useSelector, useDispatch } from '../../redux/store';

const Container = styled(Box)(({ theme }) => ({
  background: 'linear-gradient(0deg, rgb(7, 20, 44) -5.86%, rgb(38, 58, 89) 104.05%)',
  padding: '3.5rem 1rem 1rem',
}));

const CustomBtn = styled(ButtonBase)(({ theme }) => ({
  height: 36,
  background: 'linear-gradient(to right top, rgb(56, 176, 227), rgb(29, 147, 210))',
  width: 128,
  fontWeight: 700,
  borderRadius: '.375rem',
  color: '#fff',
  fontSize: 14,
}));

const ButtonTxt = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 600,
  flex: 1,
  padding: '0.75rem',
}));

const ButtonBox = styled(Stack)(({ theme }) => ({
  border: '2px solid rgba(244, 244, 245, .1)',
  borderRadius: '0.5rem',
  padding: '1rem',
  cursor: 'pointer',
}));

const LabelBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const Label = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: 14,
  background: 'linear-gradient(to bottom, rgba(49, 49, 49), rgba(77, 77, 77))',
  padding: '.325rem 3rem',
  borderBottomLeftRadius: 999,
  borderBottomRightRadius: 999,
  borderBottom: '2px solid rgb(96, 96, 96)',
  borderLeft: '2px solid rgb(96, 96, 96)',
  borderRight: '2px solid rgb(96, 96, 96)',
}));

const CloseBtn = styled(Iconify)(({ theme }) => ({
  width: 20,
  height: 20,
  color: '#fff',
  position: 'absolute',
  top: '0.5rem',
  right: '0.5rem',
  cursor: 'pointer',
}));

const ContactPopup = ({ telegram, line }) => {
  const { translate } = useLocales();

  const { isOpenCS } = useSelector((x) => x?.settings);

  const dispatch = useDispatch();

  const onOpenSocial = (link) => {
    window.open(link, '_blank');
  };

  return (
    <Dialog
      PaperProps={{
        sx: {
          m: '1rem',
          position: 'relative',
        },
      }}
      fullWidth
      open={isOpenCS}
      onClose={() => dispatch(setIsOpenCS(false))}
    >
      <Container>
        <CloseBtn icon="ic:round-close" onClick={() => dispatch(setIsOpenCS(false))} />
        <LabelBox onClick={() => dispatch(setIsOpenCS(false))}>
          <Label>{translate('contact_teller')}</Label>
        </LabelBox>
        <Stack spacing={'1.25rem'}>
          {telegram && (
            <ButtonBox direction="row" alignItems="center" onClick={() => onOpenSocial(telegram)}>
              <Image src={require('../../assets/social/telegram.png')} sx={{ width: '40px', height: '40px' }} />
              <ButtonTxt>{translate('telegram')}</ButtonTxt>
              <CustomBtn>{translate('click')}</CustomBtn>
            </ButtonBox>
          )}
          {line && (
            <ButtonBox direction="row" alignItems="center" onClick={() => onOpenSocial(line)}>
              <Image src={require('../../assets/social/line.png')} sx={{ width: '40px', height: '40px' }} />
              <ButtonTxt>{translate('line')}</ButtonTxt>
              <CustomBtn>{translate('click')}</CustomBtn>
            </ButtonBox>
          )}
        </Stack>
      </Container>
    </Dialog>
  );
};

export default ContactPopup;
